import {useSubscription} from '../../providers/subscription/useSubscription.ts'
import {useProjects} from '../../providers/projects/useProjects.ts'
import {Flex, Title} from '@mantine/core'
import {LimitedFeatureBadge} from '../../components/limitedFeatureBadge/LimitedFeatureBadge.tsx'
import {ProjectsList} from './ProjectsList.tsx'

export const ProjectsScreen = () => {
  const {activeSubscriptionTier} = useSubscription()
  const {activeProjects, loading} = useProjects()

  const disabled = loading || activeSubscriptionTier.tier === 'none'

  return (
    <div style={{display: 'flex', justifyContent: 'center'}}>
      <div style={{flex: 1, display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 800}}>
        <Flex>
          <Title order={3}>Projects</Title>
          <Flex flex={1} justify={'end'}>
            <LimitedFeatureBadge
              max={activeSubscriptionTier.features.maxActiveProjects}
              current={activeProjects.length}
              loading={loading}
            />
          </Flex>
        </Flex>

        <ProjectsList disabled={disabled} />
      </div>
    </div>
  )
}
